export enum SessionStatusCode {
    WAITING_FOR_PAYMENT = 'WaitingForPayment',
    PROCESS_COMPLETED = 'ProcessCompleted',
    PAYMENT_CANCELED = 'PaymentCanceled',
    REGISTER_POLICY_ERROR = 'RegisterPolicyError',
    WAITING_TO_GET_PDF = 'WaitingToGetPdf',
    WAITING_FOR_NEW_AMOUNT_ACCEPT = 'WaitingForNewAmountAccept',
}
